import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { Flex } from '@Calix-Commerce/design-system/layout';
import {
  PrimaryTable,
  PrimaryTableRowDotted as BaseTableRowDotted,
  PrimaryTableRow as BaseTableRow,
} from '@Calix-Commerce/design-system/components';

export const Table = styled(PrimaryTable)`
  th:first-of-type > div {
    width: 2rem;
  }

  th:nth-of-type(2) {
    width: 60%;
  }

  th:last-child {
    text-align: right;
    padding-right: 2.42rem;
  }
`;

export const PartNumber = styled.div`
  color: ${({ theme }) => theme.colors.secondary};
  font-weight: 700;
`;

export const ExpandableCell = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  padding-left: 0.8rem;

  & > svg {
    position: absolute;
    left: -1.2rem;
    width: 2.3rem;
    height: 2.3rem;
  }
`;

export const TableRowDotted = styled(BaseTableRowDotted)`
  td {
    padding-top: 1.8rem;
  }

  td:last-child {
    text-align: right;
    padding-right: 2.42rem;
  }
`;

export const TableRow = styled(BaseTableRow)`
  td {
    padding-bottom: 1.8rem;
  }
`;

export const TrackingLink = styled.a`
  color: ${({ theme }) => theme.colors.item};
  cursor: pointer;
`;

export const InfoFields = styled.div`
  display:grid;
  grid-template-columns:50% 50%;
  padding-top: ${({ topSpacing }) => (topSpacing ? '0.8rem' : 0)};
  background: ${({ background = 'transparent' }) => background};
  ${({ padded }) =>
    padded
      ? css`
          padding: 0.4rem 1rem;
          margin-left: -1rem;
          margin-right: -1rem;
        `
      : ''}
`;

export const ItemTrackingBlock = styled(Flex)`
  padding-top: ${({ topSpacing }) => (topSpacing ? '0.8rem' : '15px')};
  background: ${({ background = 'transparent' }) => background};
  ${({ padded }) =>
    padded
      ? css`
          padding: 0.4rem 1rem;
          margin-left: -1rem;
          margin-right: -1rem;
        `
      : ''}
  height: auto;

  .pallet-list-container {
    display: flex;
    flex-direction: column;

    .pallet-number-list {
      li {
        margin-top: 5px;
      }
    }
  }
`;

export const NotShippedInfo = styled.b`
  display: block;
  margin-top: 15px;
`;

export const InfoColumn = styled.div`
  width: 20rem;

  & > div {
    margin-bottom: 0.3rem;
  }
`;
